var bookshelf = require("../index-extended");

module.exports = bookshelf.model("User", {
  tableName: "user",
  entityTimestampable: true,

  format(attrs) {
    delete attrs["$id"];
    delete attrs["@context"];
    delete attrs["@id"];
    delete attrs["@type"];
    delete attrs["agencyId"];

    return attrs;
  },
});
